import { SPACING } from '@alto/design-library-tokens';

type PaddingSize = typeof SPACING.STATIC.XS | typeof SPACING.STATIC.MD;

const FOUR_OR_MORE_OPTIONS = 4;

/**
 * Horizontal padding for ButtonSelector option cells and the selected overlay.
 * Mid-width phones use MD padding with 4+ columns, leaving too little room for labels like "No tip".
 * XS padding when the screen is narrow or when many options share one row.
 */
export const getOptionHorizontalPadding = (isXSScreen: boolean, itemsQuantity: number): PaddingSize => {
  if (isXSScreen || itemsQuantity >= FOUR_OR_MORE_OPTIONS) {
    return SPACING.STATIC.XS;
  }

  return SPACING.STATIC.MD;
};
